
// Vue reactivity
import { defineComponent } from 'vue';

// icons
import { close } from 'ionicons/icons';

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon,
        IonSlides, IonSlide, modalController } from '@ionic/vue';
        
export default defineComponent({
  name: 'ImageModal',
  props: ["imageLink", "caption", "isPetCardImg"],
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon,
                IonSlides, IonSlide, },
  setup() {
    const closeModal = async () => { await modalController.dismiss() };
    const slideOpts = {
      zoom: true,
      allowSlideNext: false,
      allowSlidePrev: false,
    };

    // 3. return variables & methods to be used in template HTML
    return {
      // icons
      close,

      // variables
      slideOpts,
      
      // methods
      closeModal,
    }
  }
});
